let number = 0

export const getUniNumber = () => number++
